import { Image, Text, View } from 'components';
import WxOpenLaunchWeapp from 'components/View/WxOpenLaunchWeapp'
import Base, { Config } from 'components/sixshot/Base';
import { history } from 'modules/navigator';
import React from 'react';
import styles from './index.module.scss';


const LEVEL_SILVER = 1
const LEVEL_GOLD = 2
const PactPath = 'https://assets.gongji58.com/sixshot/contractPaper.png'   //合同图片链接

interface State {
  vipList: {
    days: number
    id: number
    info_list: any
    level: number   //1：银会员；   2：金会员
    type: number     //1长期；   2替班
    name: string
    price: string
    cost: string
    status: number
  }[]
  level?: number
  column?: string
  type: number
  vipInfo?: any
  userInfo: any
}


/**
 * type: 1 | 2       //1长期；  2替班
 * level: 1 | 2      //表示2金钻、1银钻
 * column: string    //表示对应的权利页面
 * ↓↓↓↓↓↓↓
 * combo      -- 替班包年卡
 * score      -- 积分
 * law        -- 律师法务咨询
 * box        -- 云盒代理
 * course     -- 维修课程
 * fault      -- 故障查询
 * agent      -- 兼职代理
 * pact       -- 驾驶员合同
 * icon       -- 专属标识
 * insurance  -- 保险
 * quality    -- 专属优质工作推荐
 * **/
export default class VipCompaire extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '会员特权'
  };

  public state: State = {
    vipList: [],
    userInfo: {},
    type: 1  //默认长期会员， 2：替班会员
  };

  public async didMount() {
    // await this.getUserInfo();
    this.init()

    console.log(this.navigator.getParams(' '+this.props.location.search))
    const params:any = this.navigator.getParams(' '+this.props.location.search) || {}
    this.setState({
      level: params.level || 2,
      column: params.column || '',
      type: params.type || 1,
    })
  }

  public didShow() {
    console.log('didShow')
    console.log(this.navigator.getParams(' '+this.props.location.search))
  }

  public render() {
    const { column, vipInfo, userInfo, type } = this.state;

    return (
      <View className={styles.container} style={{backgroundImage: 'url('+this.assets.sixshot.vipCompaireBg+')'}}>
        
        {column == 'combo' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>替班包年卡</View>
              <View className={styles.ul}>
                <Text className={styles.li}>网站上所有替班工作</Text>
                <Text className={styles.li}>一年内免费任意拨打</Text>
                <Text className={styles.li}>价值<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'combo') || {}).price || ''}</Text>元</Text>
                
              </View>
            </View>
            
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconCombo} width="41.5" className={styles.img} />
              </View>
            
          </View>
        }
        {column == 'score' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>赠送{(this.vipSelectedInfo.find(e => e.column == 'score') || {}).value || ''}积分</View>
              <View className={styles.ul}>
                <Text className={styles.li}>赠送《51驾驶员》平台</Text>
                <Text className={styles.li}><Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'score') || {}).value || ''}</Text>积分，永久有效</Text>
                {type == 2? (
                  <Text className={styles.li}>可以预定<Text className={this.cx(styles.yellow, styles.b, styles.tag)}>{(this.vipSelectedInfo.find(e => e.column == 'score') || {}).sub || ''}</Text>次工作提醒</Text>
                ): (
                  <Text className={styles.li}>可以拨打<Text className={this.cx(styles.yellow, styles.b, styles.tag)}>{(this.vipSelectedInfo.find(e => e.column == 'score') || {}).call || ''}</Text>次招聘电话</Text>
                )}
                <Text className={styles.li}>价值<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'score') || {}).price || ''}</Text>元</Text>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.recordBox}>
                <View className={styles.bord} />
                <View className={styles.h2}>
                  <Image src={this.assets.sixshot.vipIconScore} className={styles.ico} />
                  <Text className={styles.txt}>赠送记录：</Text>
                </View>
                {vipInfo &&
                  <Text className={styles.p}>{this.interface.formatDate((vipInfo.create_time || 0)*1000, 'yyyy年mm月dd日')}已赠送至【{userInfo.nickname || ''}】</Text>
                }
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconScore} width="41" className={styles.img} />
              </View>
            )}
            
          </View>
        }
        {column == 'law' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>专业律师法务咨询权</View>
              <View className={styles.ul}>
                <Text className={styles.li}>一年<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'law') || {}).value || ''}</Text>次</Text>
                <Text className={styles.li}>专业律师<Text className={this.cx(styles.yellow)}>在线法务咨询</Text>权</Text>
                <Text className={styles.li}>【仅限本人的劳务纠纷】</Text>
                <Text className={styles.li}>价值<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'law') || {}).price || ''}</Text>元</Text>
                <View className={this.cx(styles.li, styles.red)} onClick={this.toIntroduce.bind(null, 'law')}>
                  <View className={styles.btn}>
                    点此查看效果
                    <Image src={this.assets.sixshot.arrRightDoubleRed} className={styles.arr} />
                  </View>
                </View>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.btnsBox}>
                <View className={this.cx(styles.btn, styles.red)} onClick={this.handleLawClick}>点此在线咨询</View>
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconLaw} width="38" className={styles.img} />
              </View>
            )}
          </View>
        }
        {column == 'box' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>智能云盒代理权</View>
              <View className={styles.ul}>
                <Text className={styles.li}>工程机械智能云盒代理权</Text>
                <Text className={styles.li}>【51工机宝】</Text>
                <Text className={styles.li}>价值<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'box') || {}).price || ''}元+ </Text></Text>
                <View className={this.cx(styles.li, styles.sm)}>
                  <Text className={styles.small}>佣金300~400/台</Text>
                  <Text className={styles.small}>如果你每个月能代销2台</Text>
                  <Text className={styles.small}>一年就可以兼职赚{(this.vipSelectedInfo.find(e => e.column == 'box') || {}).price || ''}元+</Text>
                </View>
                <View className={this.cx(styles.li, styles.red)} onClick={this.toIntroduce.bind(null, 'box')}>
                  <View className={styles.btn}>
                    点此查看效果
                    <Image src={this.assets.sixshot.arrRightDoubleRed} className={styles.arr} />
                  </View>
                </View>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.btnsBox}>
                <View className={this.cx(styles.btn, styles.red)} onClick={this.toAdvice}>点此咨询代理</View>
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconBox} width="43.5" className={styles.img} />
              </View>
            )}
          </View>
        }
        {column == 'course' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>懂维修，工资高，机会多</View>
              <View className={styles.ul}>
                <Text className={styles.li}>赠送挖机<Text className={this.cx(styles.yellow)}>维修学习视频课</Text></Text>
                <Text className={styles.li}>提升你的专业技能</Text>
                <Text className={styles.li}>价值<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'course') || {}).price || ''}</Text>元</Text>
                <View className={this.cx(styles.li, styles.red)} onClick={this.toIntroduce.bind(null, 'course')}>
                  <View className={styles.btn}>
                    点此查看效果
                    <Image src={this.assets.sixshot.arrRightDoubleRed} className={styles.arr} />
                  </View>
                </View>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.btnsBox}>
                <WxOpenLaunchWeapp
                  username="gh_a718ca0d65c0"
                  path="/pages/video/lists/index?id=13"
                  style={{width: '100%'}}
                >
                  <View style={{
                    width: '178.5px',
                    textAlign: 'center',
                    border: 'solid 1px #A0A0A0',
                    borderRadius: '100px',
                    fontSize: '16px',
                    lineHeight: 1,
                    padding: '7px 0',
                    margin: '0 auto 20px',
                      borderColor: '#DD0011',
                      color: '#DD0011',
                  }}>点此查看视频课</View>
                </WxOpenLaunchWeapp>
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconCourse} width="44" className={styles.img} />
              </View>
            )}
            
          </View>
        }
        {column == 'fault' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>故障代码方案查询</View>
              <View className={styles.ul}>
                <Text className={styles.li}>挖机故障代码+解决方案</Text>
                <Text className={styles.li}>查询免费使用<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'fault') || {}).value || ''}年</Text></Text>
                <Text className={styles.li}>价值<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'fault') || {}).price || ''}</Text>元</Text>
                <View className={this.cx(styles.li, styles.red)} onClick={this.toIntroduce.bind(null, 'fault')}>
                  <View className={styles.btn}>
                    点此查看效果
                    <Image src={this.assets.sixshot.arrRightDoubleRed} className={styles.arr} />
                  </View>
                </View>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.btnsBox}>
                <WxOpenLaunchWeapp
                  username="gh_a718ca0d65c0"
                  path="/pages/data/code/index?type=6"
                  style={{width: '100%'}}
                >
                  <View style={{
                    width: '178.5px',
                    textAlign: 'center',
                    border: 'solid 1px #A0A0A0',
                    borderRadius: '100px',
                    fontSize: '16px',
                    lineHeight: 1,
                    padding: '7px 0',
                    margin: '0 auto 20px',
                      borderColor: '#DD0011',
                      color: '#DD0011',
                  }}>点此查询</View>
                </WxOpenLaunchWeapp>
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconFault} width="40" className={styles.img} />
              </View>
            )}
          </View>
        }
        {column == 'agent' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>
                <Text>51平台未来会提供资源</Text>
                <Text>让驾驶员多赚钱</Text>
              </View>
              <View className={styles.ul}>
                <Text className={styles.li}>兼职代理</Text>
                <Text className={styles.li}>51平台<Text className={this.cx(styles.yellow)}>推广赚钱</Text>机会</Text>
                <Text className={styles.li}>价值<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'agent') || {}).price/10000 || ''}万+</Text></Text>
                <View className={this.cx(styles.li, styles.red)} onClick={this.toIntroduce.bind(null, 'agent')}>
                  <View className={styles.btn}>
                    点此查看效果
                    <Image src={this.assets.sixshot.arrRightDoubleRed} className={styles.arr} />
                  </View>
                </View>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.btnsBox}>
                <View className={this.cx(styles.btn, styles.red)} onClick={this.toAdvice}>点此申请加入</View>
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconAgent} width="36" className={styles.img} />
              </View>
            )}
          </View>
        }
        {column == 'pact' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>
                <Text>专业律师打造的</Text>
                <Text>驾驶员合同</Text>
              </View>
              <View className={styles.ul}>
                <Text className={styles.li}>驾驶员专属劳动合同一份</Text>
                <Text className={styles.li}>由<Text className={this.cx(styles.yellow)}>专业律师</Text>打造</Text>
                <Text className={styles.li}>【电子版下载】</Text>
                <Text className={styles.li}>价值<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'pact') || {}).price || ''}</Text>元</Text>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.btnsBox}>
                {this.isMiniProgram? (
                  <View className={this.cx(styles.btn, styles.red)} onClick={this.handleClickPact}>点此下载劳动合同</View>
                ): (
                  <a className={this.cx(styles.btn, styles.red)} href={PactPath} download>点此下载劳动合同</a>
                )}
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconPact} width="37.5" className={styles.img} />
              </View>
            )}
            
          </View>
        }
        {column == 'icon' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>专属钻石标识简历</View>
              <View className={styles.ul}>
                <Text className={styles.li}>点亮金色“<Text className={this.cx(styles.yellow)}>金钻驾驶员</Text>”标识</Text>
                <Text className={styles.li}>让简历一眼被老板看中</Text>
                <Text className={styles.li}>获取更多机会！</Text>
                <View className={this.cx(styles.li, styles.red)} onClick={this.toIntroduce.bind(null, 'icon')}>
                  <View className={styles.btn}>
                    点此查看效果
                    <Image src={this.assets.sixshot.arrRightDoubleRed} className={styles.arr} />
                  </View>
                </View>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.btnsBox}>
                <View className={this.cx(styles.btn, styles.red)} onClick={this.handleClickIcon}>点此制作简历</View>
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconIcon} width="41.5" className={styles.img} />
              </View>
            )}
          </View>
        }
        {column == 'insurance' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>个人意外死亡伤残险</View>
              <View className={styles.ul}>
                <Text className={styles.li}>驾驶员个人意外险 </Text>
                <Text className={styles.li}>由【<Text className={this.cx(styles.yellow)}>{
                  this.getDecodeUri((this.vipSelectedInfo.find(e => e.column == 'insurance') || {}).name || '')
                }</Text>】提供</Text>
                <Text className={styles.li}>保额<Text className={this.cx(styles.yellow, styles.b)}>{(this.vipSelectedInfo.find(e => e.column == 'insurance') || {}).quota/10000 || ''}万元</Text></Text>
                <View className={this.cx(styles.li, styles.red)} onClick={this.toIntroduce.bind(null, 'insurance')}>
                  <View className={styles.btn}>
                    点此查看效果
                    <Image src={this.assets.sixshot.arrRightDoubleRed} className={styles.arr} />
                  </View>
                </View>
              </View>
            </View>
            {this.isVip? (
              <View className={styles.btnsBox}>
                <View className={this.cx(styles.btn, styles.red)} onClick={this.handleClickInsurance}>点此填写保险投保信息</View>
              </View>
            ): (
              <View className={styles.bottom}>
                <Image src={this.assets.sixshot.vipIconInsurance} width="35" className={styles.img} />
              </View>
            )}
            
          </View>
        }
        {column == 'quality' && 
          <View className={styles.box}>
            <View className={styles.top}>
              <View className={styles.h2}>专属优质工作推荐</View>
              <View className={styles.ul}>
                <Text className={styles.li}>“<Text className={this.cx(styles.yellow)}>钻石会员专属</Text>”招聘</Text>
                <Text className={styles.li}>专属优质工作推荐</Text>
                <Text className={styles.li}>更快找到好工作！</Text>
                <View className={this.cx(styles.li, styles.red)} onClick={this.toIntroduce.bind(null, 'quality')}>
                  <View className={styles.btn}>
                    点此查看效果
                    <Image src={this.assets.sixshot.arrRightDoubleRed} className={styles.arr} />
                  </View>
                </View>
              </View>
            </View>
            <View className={styles.bottom}>
              <Image src={this.assets.sixshot.vipIconVip} width="41" className={styles.img} />
            </View>
          </View>
        }

        <View className={styles.backBtn}>
          <View className={styles.btn} onClick={this.handleBack}>{'<< 点此返回'}</View>  
        </View>
        
      </View>
    );
  }


  private get vipGold() {
    const { vipList, type } = this.state
    let res:any = vipList.find(e => (e.level == LEVEL_GOLD && e.type == type)) || {}
    return {...res, alias: '金钻'}
  }
  private get vipSilver() {
    const { vipList, type } = this.state
    let res:any =  vipList.find(e => (e.level == LEVEL_SILVER && e.type == type)) || {}
    return {...res, alias: '银钻'}
  }
  private get vipSelected() {
    const { vipList, type, level } = this.state
    let res:any =  vipList.find(e => (e.level == level && e.type == type))
    return res || {}
  }
  private get vipSelectedInfo() {
    return this.vipSelected? (this.vipSelected.info_list || []): []
  }

  private get isVip() {
    const { vipInfo } = this.state
    return vipInfo && !!vipInfo.id
    // return true  //测试
  }

  private get isMiniProgram() {
    return this.interface.uaEnv.isWechatMp()
  }

  private getDecodeUri = (str) => {
    // console.log('decodeURI:', String(str), decodeURI(str))
    // console.log('test: ', '\u4e2d\u56fd', decodeURI('\u4e2d\u56fd'))  //正常
    
    let test = JSON.stringify(str)
    test = test.replace(/\\\\/g, '\\')
    return JSON.parse(test)
    // return decodeURI(str)   //不能直接转
  }


  private handleBack = () => {
    if(this.interface.uaEnv.isWechatMp()){
      window.wx.miniProgram.navigateBack()
    }else if(this.interface.uaEnv.isReactNative) {
      this.interface.postMessage('back')
    }else {
      this.navigator.back()
    }
  }


  private toIntroduce = (column) => {
    history.push('/sixshot/vip/introduce',{column})
  }
  private toAdvice = () => {
    history.push('/sixshot/vip/adviceApply')
  }

  private handleClickIcon = () => {
    if(this.isMiniProgram){
      window.wx.miniProgram.navigateTo({url: '/pages/resume/publish/index'})
    }else {
      alert('请前往‘51驾驶员’小程序发布！')
    }
  }
  private handleClickInsurance = () => {
    if(this.isMiniProgram){
      window.wx.miniProgram.navigateTo({url: '/pages/vip/insurance/index'})
    }else {
      alert('请前往‘51驾驶员’小程序个人中心使用！')
    }
  }
  private handleClickPact = () => {
    window.wx.miniProgram.navigateTo({url: '/pages/help/downloadImg/index?path='+PactPath})
  }

  private handleLawClick = () => {
    if(this.isMiniProgram){
      window.wx.miniProgram.navigateTo({url: '/pages/vip/lawAsk/index'})
    }else {
      alert('请前往‘51驾驶员’小程序体验！')
    }
  }





  

  private init = async() => {
    this.getVipInfo()
    this.getUserInfo()
    //测试


    const { body } = await this.apiClient.base.vipPlus({})
    if(body) {
      this.setState({
        vipList: body || []
      })
    }
  }  

  private getVipInfo = async() => {
    const { body } = await this.apiClient.base.vipPlusInfo()

    // if(!body || !body.id) {
    //   //购买前：云盒、兼职、维修课程、钻石工作机会、钻石标识，省去中间页面，直接跳转效果图页。
    //   const { column } = this.state
    //   if(column == 'box' || column == 'agent' || column == 'course' || column == 'quality' || column == 'icon'){
    //     this.toIntroduce(column)
    //   }
    // }
    
    if(body) {
      this.setState({
        vipInfo: body
      })  
    }
  }
  private getUserInfo = async() => {
    const { body } = await this.apiClient.base.userinfo();
    if(body) {
      this.setState({
        userInfo: body || {}
      })  
    }
    
  }
  
}

